import React, { useEffect, useState } from 'react'

interface CheckboxComponentProps {
  value: boolean // Value should have a default boolean
  onChange: (checked: boolean) => void // Function to handle change
}

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
  value,
  onChange,
}) => {
  // Local state to manage the checked state of the checkbox
  const [checked, setChecked] = useState<boolean>(value) // Initialize with result or value

  // Sync local state with result and value whenever they change
  useEffect(() => {
    setChecked(value)
  }, [value])

  // Handle the change event
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked

    // Update the parent component via onChange
    onChange(isChecked)

    // Also update local state
    setChecked(isChecked)
  }

  return (
    <div className="col-span-1 flex items-center space-x-2">
      <input
        checked={checked} // Use local state to control the checkbox
        className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-offset-0"
        type="checkbox"
        onChange={handleChange}
      />
    </div>
  )
}

export default CheckboxComponent
